import { generatePdf } from "@saleor/utils/pdf/handler";

export const useUpdatePrint = order => {
  generatePdf({ order }, "/generate-shipping-label");
};
